/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ScreenHeaderAddressQueryVariables = Types.Exact<{
  addressId: Types.Scalars['ID']['input'];
}>;

export type ScreenHeaderAddressQuery = {
  readonly __typename?: 'Query';
  readonly address: {
    readonly __typename: 'Address';
    readonly id: string;
    readonly name: string | null;
  } | null;
};

export type ScreenHeaderRestaurantQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type ScreenHeaderRestaurantQuery = {
  readonly __typename?: 'Query';
  readonly restaurant: {
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly name: string;
    readonly isOutpost: boolean;
  } | null;
};

export const ScreenHeaderAddressDocument = gql`
  query ScreenHeaderAddress($addressId: ID!) {
    address(addressId: $addressId) {
      __typename
      id
      name
    }
  }
`;

export function useScreenHeaderAddressQuery(
  options: Omit<Urql.UseQueryArgs<ScreenHeaderAddressQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ScreenHeaderAddressQuery, ScreenHeaderAddressQueryVariables>({
    query: ScreenHeaderAddressDocument,
    ...options,
  });
}
export const ScreenHeaderRestaurantDocument = gql`
  query ScreenHeaderRestaurant($id: ID!) {
    restaurant(id: $id) {
      __typename
      id
      name
      isOutpost
    }
  }
`;

export function useScreenHeaderRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<ScreenHeaderRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ScreenHeaderRestaurantQuery, ScreenHeaderRestaurantQueryVariables>({
    query: ScreenHeaderRestaurantDocument,
    ...options,
  });
}
